import React from "react";
import { Link } from "react-router-dom";
import "./CustomerBenefits.css";

export default function BenefitsLayout({ title, description, error, success, publicView = false, token = "", children }) {
  const suffix = token ? `?token=${encodeURIComponent(token)}` : "";
  return <main className="benefits-page container-fluid py-4 px-3 px-lg-4">
    <header className="benefits-header"><div><span className="benefits-eyebrow">ĐỒNG TIẾN · KHÁCH HÀNG</span><h1>{title}</h1><p>{description}</p></div>
      <nav aria-label="Khách hàng và ưu đãi"><Link to={`/customer-points${suffix}`}>Tra cứu điểm</Link><Link to={`/customer-vouchers${suffix}`}>Kho Voucher</Link>{!publicView && <><Link to="/customer-lookup-links">Tạo link Zalo</Link><Link to="/voucher-management">Phát hành Voucher</Link><Link to="/customer-vouchers/manage">Quản lý kho Voucher</Link><Link to="/promotion-management">Ưu đãi cửa hàng</Link><Link to="/admin">Quản trị</Link></>}</nav>
    </header>
    {error && <div className="alert alert-danger" role="alert">{error}</div>}
    {success && <div className="alert alert-success" role="status">{success}</div>}
    {children}
  </main>;
}

export function BenefitPager({ page, onPage, hasNext, busy }) {
  return <nav className="d-flex justify-content-end align-items-center gap-3 mt-3" aria-label="Phân trang">
    <button className="btn btn-outline-secondary" disabled={busy || page <= 1} onClick={() => onPage(page - 1)}>Trang trước</button>
    <span>Trang {page}</span><button className="btn btn-outline-secondary" disabled={busy || !hasNext} onClick={() => onPage(page + 1)}>Trang sau</button>
  </nav>;
}
